import { render } from "./AraucariaLoader.vue?vue&type=template&id=09b7520a"
import script from "./AraucariaLoader.vue?vue&type=script&lang=js"
export * from "./AraucariaLoader.vue?vue&type=script&lang=js"

import "./AraucariaLoader.vue?vue&type=style&index=0&id=09b7520a&lang=css"

import exportComponent from "/codebuild/output/src947608915/src/marketplace-landing-deprecated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__